import React  from 'react';
//import ReactDOM from "react-dom";

import { BrowserRouter as Router, Redirect, Route, Switch, Link } from "react-router-dom";

import Nav      from './Nav'
import Tiles    from './Tiles'
import './App.css';

import { reqEndpoint } from "./Server";

// if !access_token (new session) --> 1) POST server request for grant_url 2) redirect to zoho grant_code amnd subsequently to /zohonvvcclient
// from /zohonvvcclient 1) POST server request for access_token + zgid 2) open to app

class Content extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loginreject : false,
            appuser: null,
            pn: 0,
            tileac: false,
            search: "",
            searchtotop: "",
            clearsearch: false
        };
        this.req = {col: null, doc: null};

        // This binding is necessary to make `this` work in the callback
        this.setPageTurner   = this.setPageTurner.bind(this);
        this.setTileAc       = this.setTileAc.bind(this);
        this.setNavSearch    = this.setNavSearch.bind(this);
        this.setClearSearch  = this.setClearSearch.bind(this);
    }

    setPageTurner(pn){
        this.setState({pn:pn});
    }
    setTileAc(tileac){
        this.setState({tileac:tileac});
    }
    setNavSearch(search){
        //console.log("+++ setNavSearch", this.props.match.params.col, !!(this.props.match.params.col))
        if(this.props.match.params.col) this.setState({searchtotop:search, clearsearch: true});
        else this.setState({search});
        //this.setState({search});
    }
    setClearSearch(){
        this.setState({clearsearch: true});
    }

    render() {

        if (this.state.appuser===false)
            return <div className="spinner">
                You are not authorized for this app
                <br />
                <Link to="/search" >Login</Link>
            </div>
        else if (!this.state.appuser) {
            //console.log("@@@ App get appuser", window.Auth)
            return  <div className="spinner">Loading app ...</div>
        }
        else if (this.state.clearsearch) {
            //console.log("=== clear search")
            this.setState({clearsearch: false});
            return <Redirect to={{pathname: "/search" , state: {from: "/"}}}/>
        }
        else if( this.req.col!==this.props.match.params.col || this.req.doc!==this.props.match.params.doc) {
            //console.log("@@@ App get search", this.req, this.props.match.params )

            this.req=this.props.match.params;
            // de search pas laten afgaan na de render
            setTimeout(()=>{
                this.setState({search: ""});
            },1);
            // risico op flickering
            return <div className="spinner">Loading search...</div>
        }
        else {
            //const user = this.state.appuser;
            //const userhref = "/"+user.tenant.id+"/user";
            if (this.state.searchtotop) {
                //console.log("=== searchtotop to search")
                this.setState({search: this.state.searchtotop, searchtotop: ""});
            }
    
            return <div>
                <Nav
                    match={this.props.match}
                    search={this.state.search}
                    setNavSearch={this.setNavSearch}
                    setClearSearch={this.setClearSearch}
                    appuser={this.state.appuser}/>

                <div className="container-fluid">

                    <div className='row '>

                        <div id="cntl" className="col-md-3"></div>

                        <div id="cntm" className="col-md-6">

                            <Tiles
                                match={this.props.match}
                                tileac={this.state.tileac}
                                setTileAc={this.setTileAc}
                                search={this.state.search}
                                setNavSearch={this.setNavSearch}
                                prevnext={this.state.pn}
                                setPageTurner={this.setPageTurner}/>
                        </div>

                        <div id="cntr" className="col-md-3"></div>

                    </div>

                </div>

            </div>
        }
    }

    async componentWillMount() {

        this.setState({ loginrequest: true });
        const usersession  = await reqEndpoint({ 
            route:"usersession", 
            appuser: this.state.appuser, 
            location: this.props.location
        })
        this.setState({ loginrequest: false});
        //console.log("+++ App.js usersession", usersession )
        if (usersession && usersession.redirect)  window.location.href = usersession.redirect;
        //else this.setState({ appuser: "access_code_to_be_confirmed_by_server" });
        else if (usersession && usersession.appuser && usersession.appuser.length) this.setState(usersession);
        else this.setState({ appuser: false });

    }
}


const RedirectRoot = () => {
    return <div><Redirect to={{pathname: "/search" , from: "/"}}/></div>
}

const Authcallback = () => {
    return <div><Redirect to={{pathname: "/search" , from: window.location.href}}/></div>
}

const Illegal = ()=>{
    return <div className="spinner">Illegal request ...</div>
};


class App extends React.Component {
    
    render() {

        return (
            <Router>
                <div>
                    <Switch>
                        <Route exact path={`/`} component={RedirectRoot} />
                        <Route exact path={`/search`} component={Content} />
                        <Route path={`/search/:col/:doc`} component={Content} />
                        <Route exact path={`/zohonvvcclient`} component={Authcallback} />
                        <Route component={Illegal} />
                    </Switch>
                </div>
            </Router>
        );
    }

}

export default App;





// WEBPACK FOOTER //
// ./src/App.js